var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row px-3" }, [
    _c(
      "div",
      { staticClass: "col-md-4" },
      [
        _c("validation-provider", {
          attrs: { rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ errors }) {
                return [
                  _c("custom-drop-down", {
                    attrs: {
                      clearable: false,
                      "custom-error-msg":
                        "Favor de seleccionar el tipo el documento.",
                      disabled: _vm.readonly,
                      error: errors[0],
                      fieldkey: "id",
                      fieldname: "name",
                      label: "Tipo de Documento:",
                      options: _vm.documentTypes,
                      placeholder: "Seleccione"
                    },
                    model: {
                      value: _vm.value.documentType,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "documentType", $$v)
                      },
                      expression: "value.documentType"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _c("div", { staticClass: "col-md-4 mt-2" }, [
      _c("div", { staticClass: "font-14 color-gray-6 ml-3 mb-1" }, [
        _vm._v(" Archivo: ")
      ]),
      _c("div", { staticClass: "font-14 color-black" }, [
        _c(
          "div",
          { staticClass: "d-flex align-align-items-center" },
          [
            _c("span", { staticClass: "color-black font-16 mr-3" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.value.details != undefined
                      ? _vm.value.details.selectedDocumentFilename
                      : ""
                  ) +
                  " "
              )
            ]),
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-file-input", {
                        ref: "attachedDocument",
                        staticClass: "file-input__extended",
                        attrs: {
                          accept: ".pdf",
                          "attachment-id": _vm.value.documentId,
                          "custom-error-msg": "Favor de anejar un documento.",
                          disabled: _vm.readonly,
                          "display-style": "normal",
                          error: errors[0],
                          "label-position": "left",
                          name:
                            _vm.value.documentId != undefined &&
                            _vm.value.selectedDocument == null
                              ? _vm.value.documentName
                              : "",
                          "on-download": _vm.onDownload,
                          required: ""
                        },
                        model: {
                          value: _vm.value.selectedDocument,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "selectedDocument", $$v)
                          },
                          expression: "value.selectedDocument"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ]),
    !_vm.readonly
      ? _c(
          "div",
          { staticClass: "col-md-4 mt-3 text-right pt-2" },
          [
            _c("action-button", {
              attrs: {
                i: "fas fa-times-circle",
                text: "Cancelar",
                variant: "outline-danger btn-cancel danger m-2 pl-4 pr-4"
              },
              on: { click: _vm.onCancel }
            }),
            _c("action-button", {
              attrs: {
                i: "fas fa-file-plus",
                text: "Añadir",
                variant: "success pl-4 pr-4"
              },
              on: { click: _vm.onAdd }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }